<script setup>
// core
import {computed, getCurrentInstance, ref} from "vue";
import {useStore} from "vuex";

// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

const store = useStore();
const tiktokIcon = require("@/assets/icons/tiktok.svg").default;
const {proxy} = getCurrentInstance();

const isLoading = ref(false);

const info = computed(() => store.state.dialogParams?.info);

const onLogout = async () => {
    isLoading.value = true;

    try {
        await store.dispatch("tiktok/logoutAccount", {
            userId: info.value?.user_id,
            moshaToast: proxy.$moshaToast,
        });

        await Promise.all([
            store.dispatch("tiktok/loadAccounts", {visibility: true}),
            store.dispatch("tiktok/loadAccounts", {visibility: false}),
        ]);

        store.commit("closeDialog");
    } finally {
        isLoading.value = false;
    }
};
</script>

<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">
            {{ $t("tiktok.logout.title") }}
            <div class="number-block">
                <img class="icon" :src="tiktokIcon"/>
                <span>{{ info?.username }}</span>
            </div>
        </h3>

        <div class="content">
            <i18n-t keypath="tiktok.logout.confirm" tag="p" class="confirm">
                <template #account>
                    <span class="value">{{ info?.username }}</span>
                </template>
            </i18n-t>

            <div class="action_container">
                <ButtonLoading :loading="isLoading" @click="onLogout">
                    {{ $t("tiktok.logout.button") }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
